import { ActionManager, ExecuteCodeAction, Scene } from "@babylonjs/core";

/**
 * Tracks keyboard state for the keys used during gameplay.
 * Registers Babylon ActionManager hooks on the provided scene.
 */
export class InputSystem {
  private keyStatus: Record<string, boolean> = {
    w: false,
    a: false,
    s: false,
    d: false,
    shift: false,
    space: false,
    b: false,
  };

  /** True only for the first frame that Space was pressed. */
  private _spaceJustPressed = false;

  constructor(scene: Scene) {
    scene.actionManager = new ActionManager(scene);

    scene.actionManager.registerAction(
      new ExecuteCodeAction(ActionManager.OnKeyDownTrigger, (evt) => {
        const key = this.normaliseKey(evt.sourceEvent);
        if (key in this.keyStatus) {
          if (key === "space" && !this.keyStatus.space) {
            this._spaceJustPressed = true;
          }
          this.keyStatus[key] = true;
        }
      })
    );

    scene.actionManager.registerAction(
      new ExecuteCodeAction(ActionManager.OnKeyUpTrigger, (evt) => {
        const key = this.normaliseKey(evt.sourceEvent);
        if (key in this.keyStatus) {
          this.keyStatus[key] = false;
        }
      })
    );
  }

  private normaliseKey(event: KeyboardEvent): string {
    return event.code === "Space" ? "space" : event.key.toLowerCase();
  }

  isPressed(key: string): boolean {
    return !!this.keyStatus[key];
  }

  /**
   * Returns true once per Space press. Call consumeSpacePress() after
   * reading to reset the flag.
   */
  get spaceJustPressed(): boolean {
    return this._spaceJustPressed;
  }

  consumeSpacePress(): void {
    this._spaceJustPressed = false;
  }
}
